"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateStackedDimensions = exports.generateDimensions = exports.getHeadlinesDimensions = exports.getPivotTableDimensions = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_charts_1 = require("@gooddata/sdk-ui-charts");
function getPivotTableDimensions(insight) {
    var row = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.ATTRIBUTE);
    var columns = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.COLUMNS);
    var measures = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.MEASURES);
    var rowAttributeIds = row ? sdk_model_1.bucketAttributes(row).map(sdk_model_1.attributeLocalId) : [];
    var columnAttributeIds = columns ? sdk_model_1.bucketAttributes(columns).map(sdk_model_1.attributeLocalId) : [];
    var measuresItemIdentifiers = measures && !sdk_model_1.bucketIsEmpty(measures) ? [sdk_model_1.MeasureGroupIdentifier] : [];
    var totals = sdk_model_1.insightTotals(insight);
    var totalsProp = totals.length ? { totals: totals } : {};
    return [
        tslib_1.__assign({ itemIdentifiers: rowAttributeIds }, totalsProp),
        {
            itemIdentifiers: tslib_1.__spreadArrays(columnAttributeIds, measuresItemIdentifiers),
        },
    ];
}
exports.getPivotTableDimensions = getPivotTableDimensions;
function getPieOrDonutDimensions(insight) {
    var viewBy = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.VIEW);
    if (viewBy && !sdk_model_1.bucketIsEmpty(viewBy)) {
        return [
            {
                itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier],
            },
            {
                itemIdentifiers: sdk_model_1.bucketAttributes(viewBy).map(sdk_model_1.attributeLocalId),
            },
        ];
    }
    return [
        {
            itemIdentifiers: [],
        },
        {
            itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier],
        },
    ];
}
function getBarDimensions(insight) {
    var viewBy = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.VIEW);
    var viewByAttributes = viewBy ? sdk_model_1.bucketAttributes(viewBy) : [];
    var stack = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.STACK);
    if (!stack || sdk_model_1.bucketIsEmpty(stack)) {
        return [
            {
                itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier],
            },
            {
                itemIdentifiers: viewByAttributes.map(sdk_model_1.attributeLocalId),
            },
        ];
    }
    return [
        {
            itemIdentifiers: sdk_model_1.bucketAttributes(stack).map(sdk_model_1.attributeLocalId),
        },
        {
            itemIdentifiers: tslib_1.__spreadArrays(viewByAttributes.map(sdk_model_1.attributeLocalId), [sdk_model_1.MeasureGroupIdentifier]),
        },
    ];
}
function getAreaDimensions(insight) {
    var viewBucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.VIEW);
    var viewByAttributes = viewBucket ? sdk_model_1.bucketAttributes(viewBucket) : [];
    var stackBucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.STACK);
    if (viewByAttributes.length > 1) {
        // only take first two view items
        var _a = viewByAttributes
            .slice(0, sdk_ui_charts_1.ViewByAttributesLimit)
            .map(sdk_model_1.attributeLocalId), viewItemIdentifier = _a[0], stackItemIdentifier = _a[1];
        return [
            {
                itemIdentifiers: [stackItemIdentifier],
            },
            {
                itemIdentifiers: [viewItemIdentifier, sdk_model_1.MeasureGroupIdentifier],
            },
        ];
    }
    if (!stackBucket || sdk_model_1.bucketIsEmpty(stackBucket)) {
        return [
            {
                itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier],
            },
            {
                itemIdentifiers: viewByAttributes.map(sdk_model_1.attributeLocalId),
            },
        ];
    }
    return [
        {
            itemIdentifiers: sdk_model_1.bucketAttributes(stackBucket).map(sdk_model_1.attributeLocalId),
        },
        {
            itemIdentifiers: tslib_1.__spreadArrays(viewByAttributes.map(sdk_model_1.attributeLocalId), [sdk_model_1.MeasureGroupIdentifier]),
        },
    ];
}
function getLineDimensions(insight) {
    var trend = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.TREND);
    var trendAttributes = trend ? sdk_model_1.bucketAttributes(trend) : [];
    var segment = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.SEGMENT);
    if (!segment || sdk_model_1.bucketIsEmpty(segment)) {
        return [
            {
                itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier],
            },
            {
                itemIdentifiers: trendAttributes.map(sdk_model_1.attributeLocalId),
            },
        ];
    }
    return [
        {
            itemIdentifiers: sdk_model_1.bucketAttributes(segment).map(sdk_model_1.attributeLocalId),
        },
        {
            itemIdentifiers: tslib_1.__spreadArrays(trendAttributes.map(sdk_model_1.attributeLocalId), [sdk_model_1.MeasureGroupIdentifier]),
        },
    ];
}
function getHeadlinesDimensions() {
    return [{ itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier] }];
}
exports.getHeadlinesDimensions = getHeadlinesDimensions;
function getScatterDimensions(insight) {
    var attribute = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.ATTRIBUTE);
    if (attribute && !sdk_model_1.bucketIsEmpty(attribute)) {
        return [
            {
                itemIdentifiers: sdk_model_1.bucketAttributes(attribute).map(sdk_model_1.attributeLocalId),
            },
            {
                itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier],
            },
        ];
    }
    return [
        {
            itemIdentifiers: [],
        },
        {
            itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier],
        },
    ];
}
// Heatmap
function getHeatmapDimensionsFromMdObj(insight) {
    return getHeatmapDimensionsFromBuckets(insight);
}
function getHeatmapDimensionsFromBuckets(insight) {
    var view = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.VIEW);
    var viewAttributes = view ? sdk_model_1.bucketAttributes(view) : [];
    var stack = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.STACK);
    if (!stack || sdk_model_1.bucketIsEmpty(stack)) {
        return [
            {
                itemIdentifiers: viewAttributes.map(sdk_model_1.attributeLocalId),
            },
            {
                itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier],
            },
        ];
    }
    return [
        {
            itemIdentifiers: viewAttributes.map(sdk_model_1.attributeLocalId),
        },
        {
            itemIdentifiers: tslib_1.__spreadArrays(sdk_model_1.bucketAttributes(stack).map(sdk_model_1.attributeLocalId), [sdk_model_1.MeasureGroupIdentifier]),
        },
    ];
}
function getBubbleDimensions(insight) {
    var view = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.VIEW);
    var viewAttributes = view ? sdk_model_1.bucketAttributes(view) : [];
    var stack = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.STACK);
    if (!stack || sdk_model_1.bucketIsEmpty(stack)) {
        return [
            {
                itemIdentifiers: viewAttributes.map(sdk_model_1.attributeLocalId),
            },
            {
                itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier],
            },
        ];
    }
    return [
        {
            itemIdentifiers: tslib_1.__spreadArrays(viewAttributes.map(sdk_model_1.attributeLocalId), sdk_model_1.bucketAttributes(stack).map(sdk_model_1.attributeLocalId)),
        },
        {
            itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier],
        },
    ];
}
/**
 * generateDimensions
 * is a function that generates dimensions based on buckets and visualization objects.
 * WARNING: It duplicates logic from pluggable visualizations.
 *          Remove once react components support pluggable visualizations.
 * @param insight - insight being visualized
 * @param type - visualization type string
 * @internal
 */
function generateDimensions(insight, type) {
    switch (type) {
        case sdk_ui_1.VisualizationTypes.TABLE: {
            return getPivotTableDimensions(insight);
        }
        case sdk_ui_1.VisualizationTypes.PIE:
        case sdk_ui_1.VisualizationTypes.DONUT:
        case sdk_ui_1.VisualizationTypes.FUNNEL: {
            return getPieOrDonutDimensions(insight);
        }
        case sdk_ui_1.VisualizationTypes.TREEMAP: {
            return getTreemapDimensionsFromMdObj(insight);
        }
        case sdk_ui_1.VisualizationTypes.LINE: {
            return getLineDimensions(insight);
        }
        case sdk_ui_1.VisualizationTypes.AREA: {
            return getAreaDimensions(insight);
        }
        case sdk_ui_1.VisualizationTypes.BAR:
        case sdk_ui_1.VisualizationTypes.BULLET:
        case sdk_ui_1.VisualizationTypes.COMBO:
        case sdk_ui_1.VisualizationTypes.COMBO2:
        case sdk_ui_1.VisualizationTypes.COLUMN: {
            return getBarDimensions(insight);
        }
        case sdk_ui_1.VisualizationTypes.HEADLINE: {
            return getHeadlinesDimensions();
        }
        case sdk_ui_1.VisualizationTypes.SCATTER: {
            return getScatterDimensions(insight);
        }
        case sdk_ui_1.VisualizationTypes.HEATMAP: {
            return getHeatmapDimensionsFromMdObj(insight);
        }
        case sdk_ui_1.VisualizationTypes.BUBBLE: {
            return getBubbleDimensions(insight);
        }
    }
    return [];
}
exports.generateDimensions = generateDimensions;
function generateStackedDimensions(insight) {
    var viewBucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.ATTRIBUTE);
    var viewAttributes = viewBucket ? sdk_model_1.bucketAttributes(viewBucket) : [];
    var stackAttribute = sdk_model_1.bucketAttribute(sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.STACK));
    return [
        {
            itemIdentifiers: stackAttribute ? [sdk_model_1.attributeLocalId(stackAttribute)] : [],
        },
        {
            itemIdentifiers: tslib_1.__spreadArrays(viewAttributes.map(sdk_model_1.attributeLocalId), [sdk_model_1.MeasureGroupIdentifier]),
        },
    ];
}
exports.generateStackedDimensions = generateStackedDimensions;
// Treemap
function getTreemapDimensionsFromMdObj(insight) {
    return getTreemapDimensionsFromBuckets(insight);
}
function getTreemapDimensionsFromBuckets(insight) {
    return getTreemapDimensionsFromAFM(insight);
}
function getTreemapDimensionsFromAFM(insight) {
    var attributes = sdk_model_1.insightAttributes(insight);
    if (attributes.length === 1) {
        return [
            {
                itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier],
            },
            {
                itemIdentifiers: attributes.map(sdk_model_1.attributeLocalId),
            },
        ];
    }
    return [
        {
            itemIdentifiers: attributes.map(sdk_model_1.attributeLocalId),
        },
        {
            itemIdentifiers: [sdk_model_1.MeasureGroupIdentifier],
        },
    ];
}
//# sourceMappingURL=dimensions.js.map